<p class="text-center"><strong>Comentarios</strong></p>
<hr>
<mat-form-field class="w-100">
  <mat-label>Comentario</mat-label>
  <textarea matInput [(ngModel)]="commentText" maxlength="500" rows="7" cols="50"></textarea>
</mat-form-field>
<br />

<div class="d-flex justify-content-center flex-column flex-md-row">
  <button mat-stroked-button (click)="save()" class="me-0 me-md-2 mb-2 mb-md-0">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
  <button mat-stroked-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
    Cerrar
  </button>
</div>
